<template>
  <section class="pt-7 px-10 roboto homecontainer mx-auto">
    <section class="w-full grid place-items-center" v-if="isSuccess">
      <img src="/image/resource/checkmark.gif" class="w-40 h-40" />
      <p
        class="text-skin-primary my-4 text-lg font-bold"
        v-text="'Pago realizado con exito.'"
      />
    </section>

    <section class="w-full grid place-items-center" v-else>
      <img src="/image/resource/failure.jpg" class="w-40 h-40" />
      <p
        class="text-skin-primary my-4 text-lg font-bold"
        v-text="'No se pudo procesar el pago, reintentelo.'"
      />
    </section>

    <router-link
      to="/v2/home"
      tag="button"
      class="add-cart-button mb-4 cursor-pointer inline-block px-4 py-2 mx-auto"
      v-text="'Ir a mis cursos'"
    />

    <CourseInteresed />
  </section>
</template>

<script>
import CourseInteresed from "../components/CourseInteresed.vue";

export default {
  components: {
    CourseInteresed,
  },
  data: () => ({
    isSuccess: true,
  }),
  mounted() {
    this.isSuccess = localStorage.getItem("paymentIsSuccess") || false;
    this.isSuccess = this.isSuccess === "success";
    localStorage.removeItem("paymentIsSuccess");
  },
};
</script>
